import { CarePathIcon, CollectionLink } from '@ksyos/design-system';
import { Link } from '@ksyos/router';
import type { EpisodeCategory } from '../../../../../common/enums/episodeCategory';
import { translateKey } from '../../../../translate';
import { episodeCategoryIconName } from '../../../elements/Icons/episodeCategoryIconName';

interface IPersonalSettingsCarePathDetailsCollectionItemProps {
    isActive: boolean;
    pathname: string;
    subtitle: string;
    title: EpisodeCategory;
}

export function PersonalSettingsCarePathDetailsCollectionLinkItem(
    props: IPersonalSettingsCarePathDetailsCollectionItemProps
) {
    return (
        <CollectionLink
            as={Link}
            mediaItem={
                <CarePathIcon
                    icon={episodeCategoryIconName(props.title)}
                    size={48}
                    variant="large-multicolor"
                />
            }
            subtitle={props.subtitle}
            title={`${translateKey(`episodeCategoryEnum.${props.title}`)} ${
                props.isActive ? '' : `(${translateKey('common.isInactive')})`
            }`}
            to={getNavigationPreferenceLink(props.title, props.isActive)}
        />
    );
    function getNavigationPreferenceLink(episodeCategory: EpisodeCategory, isActive: boolean) {
        if (isActive) {
            return `${props.pathname}/carePaths/${episodeCategory}`;
        }

        return `${props.pathname}/inactiveCarePaths/${episodeCategory}`;
    }
}
